<template>
  <div
    class="culturalCustomDetail"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="culturalCustomMadeTop">
      <div class="section eng_section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <span @click="goCulturalCustomMade"
            >AI assisted cultural and creative customization</span
          >
          <span>&nbsp;>&nbsp;</span>
          <span class="color">Transfer</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="culturalCustomDetail_content">
      <div class="section">
        <div class="four">
          <div class="title wow animate__fadeInDown animate__animated">
            Transfer of Regong Art Style
          </div>
          <div class="content_bottom">
            <el-upload
              class="upload-demo"
              :action="redirectUrl"
              :show-file-list="false"
              :on-success="handleSuccess"
              :headers="{ token }"
            >
              <!-- :before-upload="beforeAvatarUpload"<控制上传图片大小> -->
              <img v-if="imageUrl" :src="url + imageUrl" class="picture" />
              <div class="img" v-else>
                <img class="img_1" src="../../assets/cultural/pc.webp" alt="" />
                <div class="uploader">Upload pictures</div>
              </div>
            </el-upload>
            <el-upload
              class="upload-demo pic"
              :action="redirectUrl"
              :show-file-list="false"
              :on-success="handleSu"
              :headers="{ token }"
            >
              <div class="style" v-if="imageURL">
                <img :src="url + imageURL" class="avatar" />
                <div class="change eng_change">Click to modify the picture</div>
              </div>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="Pic">
              <div class="loading" @click="inspect">
                <img :src="url + imgURL" alt="" class="pic" v-if="imgURL" />
                <img
                  class="img_2"
                  v-else
                  src="../../assets/cultural/pc_1.webp"
                  alt=""
                />
              </div>
            </div>
            <div class="composed eng_composed">
              <el-button @click="composed" type="primary" class="move">
                <i class="el-icon-sort"></i>
                <span class="title eng_title">Conversion style migration</span>
              </el-button>
              <el-button
                class="download"
                size="small"
                type="primary"
                @click="download(url + imgURL, 'photo')"
                >Save picture</el-button
              >
            </div>
          </div>
          <div class="mobile_content_bottom">
            <div class="mobile_content_bottom_top">
              <el-upload
                class="upload-demo"
                :action="redirectUrl"
                :show-file-list="false"
                :on-success="handleSuccess"
                :headers="{ token }"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="imageUrl" :src="url + imageUrl" class="picture" />
                <div class="img" v-else>
                  <img
                    class="img_1"
                    src="../../assets/cultural/pc.webp"
                    alt=""
                  />
                  <div class="uploader">Upload pictures</div>
                </div>
                <el-button type="primary" class="uploder_button eng_button"
                  >Upload pictures</el-button
                >
              </el-upload>
              <el-upload
                class="upload-demo pic"
                :action="redirectUrl"
                :show-file-list="false"
                :on-success="handleSu"
                :headers="{ token }"
                :before-upload="beforeAvatarUpload"
              >
                <div class="style" v-if="imageURL">
                  <img :src="url + imageURL" class="avatar" id="mochu_img" />
                  <div class="change eng_change">Modify the picture</div>
                </div>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="Pic">
                <img :src="url + imgURL" alt="" v-if="imgURL" class="pic" />
                <div class="uploder_pic" v-else>
                  <img
                    class="img_2"
                    src="../../assets/cultural/pc_1.webp"
                    alt=""
                  />
                  <div class="uploader">Convert pictures</div>
                </div>
              </div>
              <el-button
                type="primary"
                class="switch eng_button"
                @click="composed"
                >Convert pictures</el-button
              >
              <el-button
                type="primary"
                class="save eng_save"
                @click="download(url + imgURL, 'photo')"
                >Save picture</el-button
              >
            </div>
          </div>
          <el-dialog :visible.sync="imgDialogVisible">
            <img width="100%" :src="url + imgURL" alt="" />
          </el-dialog>
          <div class="content_footer">
            <div class="left">
              <img src="../../assets/cultural/jiansuo/76.png" alt="" />
            </div>
            <div class="right">
              <div class="title_one eng_title_one">
                Use Cases and Introduction
              </div>
              <div class="introduce">
                <p>
                  Instructions for use: You can click the upload image button to
                  upload the image with the desired migration style, and click
                  the run button to perform the Regong art style conversion. You
                  can also adjust the target style yourself and click the Modify
                  Style button to upload your own style image. The runtime of
                  this beta version may vary depending on server load and image
                  size. Please be patient and wait; Need to queue when there are
                  too many users; Please respect religious customs when using;
                  This website is not responsible for the content and security
                  of images migrated by users.
                </p>
                <p>
                  Migration algorithm support：Xinjie Li, Yang Zhao, Xiaojuan
                  Zhang, Content-aware Regong Art Style Transfer Network.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">Contact Number：{{templeContact}}</div>
      <div class="tel">Email：regong_art_db@163.com</div>
      <div class="contact" slot="reference">
        <div class="made">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">Manual customization services</div>
          <div class="hidden-sm-and-up">Customized services</div>
        </div>
      </div>
    </el-popover>
  </div>
  <div class="culturalCustomDetail" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="culturalCustomMadeTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)"> ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <span @click="goCulturalCustomMade"
            >AIརམ་འདེགས་རིག་གཏོད་ཁྱད་བཟོ།</span
          >
          <span>&nbsp;>&nbsp;</span>
          <span class="color"> སྤོ་སྣུར། </span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="culturalCustomDetail_content">
      <div class="section">
        <div class="four">
          <div class="title wow animate__fadeInDown animate__animated">
            བཅུ་བདུན།རེབ་གོང་ཇུས་འགོད་ཁྱད་ཆོས་ཀྱི་གནས་སྤོ།
          </div>
          <div class="content_bottom">
            <el-upload
              class="upload-demo"
              :action="redirectUrl"
              :show-file-list="false"
              :on-success="handleSuccess"
              :headers="{ token }"
            >
              <!-- :before-upload="beforeAvatarUpload"<控制上传图片大小> -->
              <img v-if="imageUrl" :src="url + imageUrl" class="picture" />
              <div class="img" v-else>
                <img class="img_1" src="../../assets/cultural/pc.webp" alt="" />
                <div class="uploader">པར་རིས།</div>
              </div>
            </el-upload>
            <el-upload
              class="upload-demo pic"
              :action="redirectUrl"
              :show-file-list="false"
              :on-success="handleSu"
              :headers="{ token }"
            >
              <div class="style" v-if="imageURL">
                <img :src="url + imageURL" class="avatar" />
                <div class="change">མནན་ན་བཟོ་བཅོས་བྱེད་ཐུབ་པའི་འདྲ་པར།</div>
              </div>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="Pic">
              <div class="loading" @click="inspect">
                <img :src="url + imgURL" alt="" class="pic" v-if="imgURL" />
                <img
                  class="img_2"
                  v-else
                  src="../../assets/cultural/pc_1.webp"
                  alt=""
                />
              </div>
            </div>
            <div class="composed">
              <el-button @click="composed" type="primary" class="move">
                <i class="el-icon-sort"></i>
                <span class="title">རྣམ་པ་བསྒྱུར་བའི་གནས་སྤོ།</span>
              </el-button>
              <el-button
                class="download"
                size="small"
                type="primary"
                @click="download(url + imgURL, 'photo')"
                >པར་རིས་ཉར་ཚགས་བྱེད་པ།</el-button
              >
            </div>
          </div>
          <div class="mobile_content_bottom">
            <div class="mobile_content_bottom_top">
              <el-upload
                class="upload-demo"
                :action="redirectUrl"
                :show-file-list="false"
                :on-success="handleSuccess"
                :headers="{ token }"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="imageUrl" :src="url + imageUrl" class="picture" />
                <div class="img" v-else>
                  <img
                    class="img_1"
                    src="../../assets/cultural/pc.webp"
                    alt=""
                  />
                  <div class="uploader">པར་རིས།</div>
                </div>
                <el-button type="primary" class="uploder_button"
                  >པར་རིས།</el-button
                >
              </el-upload>
              <el-upload
                class="upload-demo pic"
                :action="redirectUrl"
                :show-file-list="false"
                :on-success="handleSu"
                :headers="{ token }"
                :before-upload="beforeAvatarUpload"
              >
                <div class="style" v-if="imageURL">
                  <img :src="url + imageURL" class="avatar" id="mochu_img" />
                  <div class="change">པར་རིས།</div>
                </div>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="Pic">
                <img :src="url + imgURL" alt="" v-if="imgURL" class="pic" />
                <div class="uploder_pic" v-else>
                  <img
                    class="img_2"
                    src="../../assets/cultural/pc_1.webp"
                    alt=""
                  />
                  <div class="uploader">པར་རིས་བརྗེ་སྒྱུར།</div>
                </div>
              </div>
              <el-button type="primary" class="switch" @click="composed"
                >པར་རིས་བརྗེ་སྒྱུར།</el-button
              >
              <el-button
                type="primary"
                class="save za_save"
                @click="download(url + imgURL, 'photo')"
                >པར་རིས་ཉར་ཚགས་བྱེད་པ།</el-button
              >
            </div>
          </div>
          <el-dialog :visible.sync="imgDialogVisible">
            <img width="100%" :src="url + imgURL" alt="" />
          </el-dialog>
          <div class="content_footer">
            <div class="left">
              <img src="../../assets/cultural/jiansuo/76.png" alt="" />
            </div>
            <div class="right">
              <div class="title_one eng_title_one">
                ཉེར་གསུམ། བཀོལ་སྤྱོད་ཀྱི་དཔེ་གཞི་དང་ངོ་སྤྲོད།
              </div>
              <div class="introduce">
                <p>
                  ཉེར་བཞི། བེད་སྤྱོད་གསལ་བཤད།
                  ཁྱེད་ཀྱིས་པར་རིས་སྐུར་བའི་མཐེབ་གནོན་མནན་ཏེ་ཁྱད་ཆོས་གནས་སྤོ་བྱེད་དགོས་པའི་པར་རིས་བརྒྱུད་སྐུར་བྱས་ཆོག
                  མཐེབ་གནོན་མནན་ཏེ་རེབ་གོང་སྒྱུ་རྩལ་གྱི་ཁྱད་ཆོས་བརྗེ་རེས་བྱ་ཆོག
                  སྐུ་ཉིད་ཀྱིས་ཀྱང་དམིགས་ཡུལ་གྱི་ཁྱད་ཆོས་ལ་འགྱུར་བ་བཏང་ཆོག
                  བཟོ་བཅོས་ཁྱད་ཆོས་ཀྱི་གཅུས་སྒོ་གནོན་ནས་སོ་སོས་བདམས་པའི་རྣམ་པ་དང་རི་མོ་བསྐུར་ཆོག
                  ཚོད་ལྟའི་པར་གཞི་དེ་འཁོར་སྐྱོད་དུས་ཚོད་ཞབས་ཞུ་འཕྲུལ་ཆས་ཀྱི་ཁུར་པོ་དང་བརྙན་རིས་ཆེ་ཆུང་མི་འདྲ་བས།
                  སྐུ་ཉིད་ཀྱིས་ངང་རྒྱུད་རིང་པོའི་སྒུག་སྡོད་ཅུང་ཙམ་བྱེད་རོགས་ཞུ།
                  སྤྱོད་མཁན་མང་དྲགས་ན་གྲལ་སྒྲིག་དགོས།
                  བེད་སྤྱོད་སྐབས་ཆོས་ལུགས་གོམས་སྲོལ་ལ་བརྩི་འཇོག་བྱ་དགོས།
                  ངེད་དྲ་ཚིགས་ཀྱིས་བེད་སྤྱོད་མཁན་གྱིས་གནས་སྤོའི་པར་རིས་ཀྱི་ནང་དོན་དང་བདེ་འཇགས་རང་བཞིན་ལ་འགན་ལེན་མི་བྱེད།
                </p>
                <p>
                  ཉེར་ལྔ། གནས་སྤོ་རྩི་ཐབས་ཀྱི་རྒྱབ་སྐྱོར།：Xinjie Li, Yang Zhao,
                  Xiaojuan Zhang, Content-aware Regong Art Style Transfer
                  Network.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">འབྲེལ་གཏུགས་ཨང་གྲངས།：{{templeContact}}</div>
      <div class="tel">སྦྲགས་ཡིག：regong_art_db@163.com</div>
      <div class="contact" slot="reference">
        <div class="made">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">རྩོལ་བྱུང་གཏན་སྲོལ་</div>
          <div class="hidden-sm-and-up">ཁྱད་བཟོའི་ཞབས་ཞུ།</div>
        </div>
      </div>
    </el-popover>
  </div>
  <div class="culturalCustomDetail" v-else>
    <Pic-top></Pic-top>
    <div class="culturalCustomMadeTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <span @click="goCulturalCustomMade">AI辅助文创定制</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">迁移</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="culturalCustomDetail_content">
      <div class="section">
        <div class="four">
          <div class="title wow animate__fadeInDown animate__animated">
            热贡艺术风格迁移
          </div>
          <div class="content_bottom">
            <el-upload
              class="upload-demo"
              :action="redirectUrl"
              :show-file-list="false"
              :on-success="handleSuccess"
              :headers="{ token }"
            >
              <!-- :before-upload="beforeAvatarUpload"<控制上传图片大小> -->
              <img v-if="imageUrl" :src="url + imageUrl" class="picture" />
              <div class="img" v-else>
                <img class="img_1" src="../../assets/cultural/pc.webp" alt="" />
                <div class="uploader">上传图片</div>
              </div>
            </el-upload>
            <el-upload
              class="upload-demo pic"
              :action="redirectUrl"
              :show-file-list="false"
              :on-success="handleSu"
              :headers="{ token }"
            >
              <div class="style" v-if="imageURL">
                <img :src="url + imageURL" class="avatar" />
                <div class="change">点击可修改图片</div>
              </div>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="Pic">
              <div class="loading" @click="inspect">
                <img :src="url + imgURL" alt="" class="pic" v-if="imgURL" />
                <img
                  class="img_2"
                  v-else
                  src="../../assets/cultural/pc_1.webp"
                  alt=""
                />
              </div>
            </div>
            <div class="composed">
              <el-button @click="composed" type="primary" class="move">
                <i class="el-icon-sort"></i>
                <span class="title">转换风格迁移</span>
              </el-button>
              <el-button
                class="download"
                size="small"
                type="primary"
                @click="download(url + imgURL, 'photo')"
                >保存图片</el-button
              >
            </div>
          </div>
          <div class="mobile_content_bottom">
            <div class="mobile_content_bottom_top">
              <el-upload
                class="upload-demo"
                :action="redirectUrl"
                :show-file-list="false"
                :on-success="handleSuccess"
                :headers="{ token }"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="imageUrl" :src="url + imageUrl" class="picture" />
                <div class="img" v-else>
                  <img
                    class="img_1"
                    src="../../assets/cultural/pc.webp"
                    alt=""
                  />
                  <div class="uploader">上传图片</div>
                </div>
                <el-button type="primary" class="uploder_button"
                  >上传图片</el-button
                >
              </el-upload>
              <el-upload
                class="upload-demo pic"
                :action="redirectUrl"
                :show-file-list="false"
                :on-success="handleSu"
                :headers="{ token }"
                :before-upload="beforeAvatarUpload"
              >
                <div class="style" v-if="imageURL">
                  <img :src="url + imageURL" class="avatar" id="mochu_img" />
                  <div class="change">修改图片</div>
                </div>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="Pic">
                <img :src="url + imgURL" alt="" v-if="imgURL" class="pic" />
                <div class="uploder_pic" v-else>
                  <img
                    class="img_2"
                    src="../../assets/cultural/pc_1.webp"
                    alt=""
                  />
                  <div class="uploader">转换图片</div>
                </div>
              </div>
              <el-button type="primary" class="switch" @click="composed"
                >转换图片</el-button
              >
              <el-button
                type="primary"
                class="save"
                @click="download(url + imgURL, 'photo')"
                >保存图片</el-button
              >
            </div>
          </div>
          <el-dialog :visible.sync="imgDialogVisible">
            <img width="100%" :src="url + imgURL" alt="" />
          </el-dialog>
          <div class="content_footer">
            <div class="left">
              <img src="../../assets/cultural/jiansuo/76.png" alt="" />
            </div>
            <div class="right">
              <div class="title_one eng_title_one">使用用例与介绍</div>
              <div class="introduce">
                <p>
                  使用说明：您可以点击上传图片按钮上传需迁移风格的图像，点击运行按钮执行热贡艺术风格转换。您也可以自行调整目标风格，点击修改风格按钮上传自选的风格图像。该测试版运行时间视服务器负载、图像尺寸会有所不同，请耐心等待；用户过多时需要排队；使用时请尊重宗教习惯；本网站不为用户所迁移图像内容和安全性负责。
                </p>
                <p>
                  迁移算法支持：Xinjie Li, Yang Zhao, Xiaojuan Zhang,
                  Content-aware Regong Art Style Transfer Network.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">联系电话：{{templeContact}}</div>
      <div class="tel">邮件：regong_art_db@163.com</div>
      <div class="contact" slot="reference">
        <div class="made">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">人工定制服务</div>
          <div class="hidden-sm-and-up">定制服务</div>
        </div>
      </div>
    </el-popover>
  </div>
</template>
<script>
import PicTop from "../../components/picsTop.vue";
import { picList, newPic } from "../../api/management";
export default {
  components: {
    PicTop,
  },
  data() {
    return {
      imageUrl: "",
      imageURL: "/uploads/regon/default_sketch.png",
      imgURL: "",
      Url: "../../assets/cultural/default.jpg",
      url: process.env.VUE_APP_WEB_URL,
      token: localStorage.getItem("token"),
      redirectUrl: encodeURI(process.env.VUE_APP_WEB_URL + "/upload"),
      query: {
        contentFile: {},
        styleFile: {},
      },
      loading: {},
      imgDialogVisible: false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      language: this.$store.state.language,
      templeContact:'18997193666'
    };
  },
  created() {},
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  methods: {
    // 是否单独打开页面展示转换后的图片
    Download_Img() {
      var img = document.getElementById("mochu_img"); // 获取要下载的图片
      var url = img.src; // 获取图片地址
      var a = document.createElement("a"); // 创建一个a节点插入的document
      var event = new MouseEvent("click"); // 模拟鼠标click点击事件
      a.download = "mochu_img"; // 设置a节点的download属性值
      a.href = url; // 将图片的src赋值给a节点的href
      a.dispatchEvent(event); // 触发鼠标点击事件
    },
    // 下载图片
    getBlob(url) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };
        xhr.send();
      });
    },
    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement("a");
        const body = document.querySelector("body");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        // fix Firefox
        link.style.display = "none";
        body.appendChild(link);
        link.click();
        body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      }
    },
    download(url, filename) {
      this.getBlob(url).then((blob) => {
        this.saveAs(blob, filename);
      });
    },
    inspect() {
      if (this.imgURL) {
        this.imgDialogVisible = true;
      }
    },
    beforeAvatarUpload(file) {
      // const isLt2M = file.size / 1024 / 1024 < 1;
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 1MB!");
      // }
      // return isLt2M;
    },
    handleSuccess(res, file) {
      this.imageUrl = res.data.fileUrl;
      this.query.contentFile.fileName = res.data.fileName;
      this.query.contentFile.fileUrl = res.data.fileUrl;
    },
    handleSu(res, file) {
      this.imageURL = res.data.fileUrl;
      this.query.styleFile.fileName = res.data.fileName;
      this.query.styleFile.fileUrl = res.data.fileUrl;
    },
    composed() {
      if (this.imageURL && this.imageUrl) {
        if (this.imageURL == "/uploads/regon/default_sketch.png") {
          this.query.styleFile.fileName = "default_sketch.png";
          this.query.styleFile.fileUrl = "/uploads/regon/default_sketch.png";
          this.loading = this.$loading({
            lock: true,
            text: "运行中，请稍候",
            background: "rgba(0,0,0,0.4)",
            spinner: "el-icon-loading",
          });
          this.getY();
        } else {
          this.loading = this.$loading({
            lock: true,
            text: "运行中，请稍候",
            background: "rgba(0,0,0,0.4)",
            spinner: "el-icon-loading",
          });
          this.getY();
        }
      } else {
        this.$message.warning("请上传左边图片");
      }
    },

    async getY() {
      const res = await newPic(this.query);
      if (res) {
        this.imgURL = res.data;
        this.loading.close();
      } else {
        this.loading.close();
      }
    },
    cen() {
      this.picSuccess();
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
    goCulturalCustomMade() {
      this.$router.push("/culturalCustomMade");
    },
  },
};
</script>
<style lang="scss">
.el-loading-spinner .el-loading-text {
  font-size: 20px;
  color: #99131a;
}
.el-icon-loading:before {
  color: #99131a;
}
.culturalCustomDetail {
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  position: relative;
  background-size: 7%;
  .image {
    position: relative;
    background: url("../../assets/newImageBgc/newImage_5.png") no-repeat center
      center;
    background-size: 100% 100%;
    height: 580px;
    .text {
      text-align: center;
      width: 2.5rem;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(0, -50%);
      color: #fff;
      font-size: 82px;
      font-family: "fangzang";
    }
    .za_text {
      font-size: 52px;
    }
    .eng_text {
      font-family: "Times New Roman", Times, serif;
      font-size: 78px;
    }
  }
  .culturalCustomMadeTop {
    border-bottom: 1px solid #f4f5f6;
    position: relative;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50px;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .culturalCustomDetail_content {
    position: relative;
    .section {
      .four {
        margin: 50px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        .title {
          font-size: 32px;
          font-family: "fangzang";
          text-align: center;
        }
        .content_top {
          text-indent: 2em;
          line-height: 24px;
          font-size: 15px;
          margin: 50px 0 60px 0;
          text-align: justify;
        }
        .content_bottom {
          margin-top: 30px;
          border: 1px #ccc dashed;
          width: 100%;
          height: 280px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          .upload-demo {
            padding-top: 2px;
            .el-upload {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              img,
              .img {
                border: 1px solid rgba(203, 203, 203, 0.4);
                background-color: #f7f7f7;
                width: 180px;
                height: 180px;
                margin-top: 20px;
                font-size: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                .uploader {
                  font-size: 18px;
                  color: #333;
                  opacity: 0.6;
                }
                .img_1 {
                  border: 0;
                  width: 22px;
                  height: 22px;
                }
              }
              .style {
                width: 180px;
                height: 180px;
                margin-top: 20px;
                font-size: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                position: relative;
                border: 0;
                background-color: #fff;
                .change {
                  z-index: 99;
                  position: absolute;
                  bottom: 0;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #fff;
                  width: 100%;
                  font-size: 18px;
                  height: 30px;
                  background: rgba(237, 32, 26, 0.6);
                }
                .eng_change {
                  font-size: 16px;
                }
                img {
                  height: 180px;
                  margin-top: 0;
                }
              }
              .el-icon-plus:before {
                display: none;
              }
            }
          }
          .Pic {
            margin-top: 20px;
            .loading {
              background-color: #f7f7f7;
              width: 180px;
              height: 180px;
              border: 1px solid rgba(203, 203, 203, 0.4);
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 180px;
                height: 180px;
              }
              .img_2 {
                width: 40px;
                height: 40px;
              }
            }
            .el-button {
              text-align: center;
              margin-top: 20px;
              border: 0;
              background: #971118;
            }
          }
          .composed {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .el-button {
              margin-left: 0;
              background: #99131a;
              border: 0;
              font-size: 16px;
              width: 120px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .move {
              display: flex;
              .title {
                font-size: 16px;
              }
            }
            .download {
              margin-top: 20px;
            }
          }
          .eng_composed {
            .el-button {
              font-size: 14px;
              width: 170px;
              .eng_title {
                font-size: 14px;
              }
            }
          }
        }
        .mobile_content_bottom {
          display: none;
        }
        .content_footer {
          margin-top: 80px;
          display: flex;
          .left {
            img {
              width: 320px;
            }
          }
          .right {
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 0 40px;
            .title_one {
              font-size: 28px;
              font-family: "fangzang";
              margin-bottom: 10px;
            }
            .introduce {
              line-height: 1.5;
              text-align: justify;
            }
          }
        }
      }
    }
    .cloud_bottom {
      position: absolute;
      right: 0%;
      bottom: 0%;
    }
    .cloud_top {
      position: absolute;
      top: 0%;
      left: 0%;
    }
  }
  .contact {
    z-index: 99;
    color: #fff;
    position: fixed;
    right: 2%;
    bottom: 30%;
    .made {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      flex-direction: column;
      width: 110px;
      height: 110px;
      border-radius: 100%;
      background-color: #99131a;
      box-shadow: 0 0 10px #99131a;
      margin-bottom: 20px;
      font-size: 12px;
      img {
        width: 32px;
        margin-bottom: 6px;
      }
    }
  }
}
@media (max-width: 768px) {
  .culturalCustomDetail {
    background: url("../../assets/newImage/index/could_right.png") no-repeat
      right bottom;
    background-size: 1rem;
    position: relative;
    padding-bottom: 0.1rem;
    .image {
      background: url("../../assets/newImageBgc/mobileCultrueBgc.jpg") no-repeat
        center center;
      background-size: cover;
      height: 3.4rem;
      position: relative;
      .text {
        font-size: 0.5rem !important;
      }
    }
    .culturalCustomMadeTop {
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
      .eng_section {
        font-size: 0.28rem;
      }
    }
    .culturalCustomDetail_content {
      padding-bottom: 0.3rem;
      background: none;
      position: relative;
      .section {
        .four {
          margin: 0.5rem 0;
          .title {
            font-size: 0.4rem;
          }
          .content_top {
            margin: 0.3rem 0;
          }
          .content_bottom {
            display: none;
          }
          .mobile_content_bottom {
            display: block;
            margin: 0.5rem 0;
            height: 3rem;
            .mobile_content_bottom_top {
              position: relative;
              display: flex;
              justify-content: space-between;
              align-items: center;
              border: 1px solid rgba(203, 203, 203, 0.4);
              padding: 0.2rem;
              .el-button {
                position: absolute;
                background: #971118;
                border: 1px solid #971118;
                bottom: -1rem;
                width: 1.6rem;
                display: flex;
                border-radius: 0;
                justify-content: center;
                align-items: center;
                height: 0.4rem;
              }
              .eng_button {
                font-size: 0.01rem;
                padding: 0.1rem;
              }
              .uploder_button {
                left: 14%;
              }
              .switch {
                left: 39%;
              }
              .save {
                left: 61%;
              }
              .eng_save {
                font-size: 0.1rem;
                height: 0.4rem;
                padding: 0;
              }
              .za_save {
                font-size: 0.1rem;
              }
              .upload-demo {
                margin-right: 0.2rem;
                background-color: #f7f7f7;
                .picture,
                .style {
                  height: 2rem !important;
                  width: 2rem !important;
                  border: 1px solid rgba(203, 203, 203, 0.4);
                  .el-icon-plus:before {
                    display: none;
                  }
                  img {
                    height: 2rem !important;
                    width: 2rem !important;
                    border: 0;
                  }
                }
                .style {
                  position: relative;
                  box-sizing: content-box !important;
                  .change {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    bottom: 0;
                    color: #fff;
                    width: 100%;
                    height: 0.4rem;
                    font-size: 0.2rem;
                    background: rgba(237, 32, 26, 0.6);
                  }
                  .eng_change {
                    font-size: 0.1rem;
                  }
                }
                .img {
                  height: 2rem !important;
                  width: 2rem !important;
                  border: 1px solid rgba(203, 203, 203, 0.4);
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  img {
                    height: 0.4rem !important;
                    width: 0.4rem !important;
                    border: 0;
                  }
                  .uploader {
                    font-size: 0.1rem !important;
                    color: #333;
                    opacity: 0.6;
                  }
                }
              }
              .Pic {
                background-color: #f7f7f7;
                height: 2rem !important;
                width: 2rem !important;
                border: 1px solid rgba(203, 203, 203, 0.4);
                display: flex;
                align-items: center;
                justify-content: center;
                .pic {
                  height: 2rem !important;
                  width: 2rem !important;
                }
                .uploder_pic {
                  display: flex;
                  align-items: center;
                  flex-direction: column;
                  justify-content: center;
                  .img_2 {
                    height: 0.4rem !important;
                    width: 0.4rem !important;
                    border: 0;
                  }
                  .uploader {
                    font-size: 0.1rem !important;
                    color: #333;
                    opacity: 0.6;
                  }
                }
              }
            }
          }
          .content_footer {
            flex-direction: column;
            align-items: center;
            margin-top: 1rem;
            .left {
              img {
                width: 6rem;
              }
            }
            .right {
              width: 6rem;
              padding: 0;
              .title_one {
                font-size: 0.4rem;
                margin-bottom: 0.1rem;
              }
              .eng_title_one {
                font-size: 0.36rem;
              }
              .introduce {
                // overflow: hidden !important;
                // overflow-wrap: break-word !important;
                // text-overflow: ellipsis !important;
                // display: -webkit-box !important;
                // -webkit-line-clamp: 4 !important;
                // -webkit-box-orient: vertical !important;
              }
            }
          }
        }
      }
      .cloudright {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 1.25rem;
      }
    }
    .contact {
      z-index: 1000;
      bottom: 35%;
      right: 1%;
      .made {
        width: 1.7rem;
        height: 1.7rem;
        padding: 0.2rem;
        img {
          width: 0.4rem;
        }
        div {
          font-size: 0.2rem;
        }
      }
    }
  }
}
</style>
